import { Box, BoxProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { forwardRef } from 'react';

type Props = {
  children: React.ReactNode;
  align?: 'center' | 'right';
} & BoxProps;

const StyledBox = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  width: '100%',
});

const StyledBoxRight = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  height: '100%',
  width: '50%',
});

const CenteredBox = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { children, align, ...rest } = props;
  if (align === 'right') {
    return (
      <StyledBoxRight ref={ref} {...rest}>
        {children}
      </StyledBoxRight>
    );
  }
  return (
    <StyledBox ref={ref} {...rest}>
      {children}
    </StyledBox>
  );
});

CenteredBox.displayName = 'CenteredBox';

export default CenteredBox;
